import scribdAuthorize from '../scribd/scribd_oauth.js';

$(function () {
  const slideshare_object = window.slideshare_object;
  // GA category
  const gaCat = 'topics';
  slideshare_object.ga(gaCat, 'pageload', null, null, true);

  /* Update status of the follow action
    *
    * Parameters:
    * elem <selector> the action-btn to be toggled
    * category url of the category to update
  */
  const followStatusUpdate = function(el, category) {
    var $el = $(el);
    var isFollowing = $el.find('.fa').hasClass('fa-check');

    var config = {
      'url':  isFollowing ? "/follow/delete" : "/follow/create",
      'data': {
        user_id : slideshare_object.user ? slideshare_object.user.id : '',
        category : category
      }
    };

    $el.find('.fa').toggleClass('fa-check fa-plus');

    $.ajax({
      url: config.url,
      data: config.data,
      dataType: 'json',
      type: 'POST',
      success: function(response) {
        if(response.success){
          slideshare_object.ga(gaCat, isFollowing ? 'unfollow_topic_click' : 'follow_topic_click', category);
        }
      },
      error: function(data) {
        $el.children().toggleClass('fa-check fa-plus');
      }
    });
  };
  
  slideshare_object.lazyloadThumbnails();
  $('.j-action-follow').on('click', function(e) {
      var $this = $(this);
      var category = $this.data('category');

      if (slideshare_object.user.loggedin){
        e.preventDefault();
        followStatusUpdate(this, category);
      } else {
        var eventConfig = {
          "event": "follow_category",
          "data": { "category" : category }
        };
        window.slideshare_object.addAfterLoginEvent(eventConfig);
        scribdAuthorize({ from_source: window.location.pathname });
      }
  });
});